import "./Exames.css";
import { getOpenFile } from "../api";
const moment = require("moment");

function Exames() {
  const exames_data = JSON.parse(sessionStorage.getItem("exames-data"));

  const nome = exames_data.paciente.nome;
  const dt_nascimento = moment(exames_data.paciente.dt_nascimento).format(
    "DD/MM/YYYY"
  );
  const cpf = exames_data.paciente.cpf;
  const id_paciente = exames_data.paciente.id_paciente;
  const resultados = exames_data.resultados_exames;

  const downloadPdfExame = (exame) => {
    const pdf_exame = exame.pdf_exame;
    const filename = exame.procedimento + "_" + exame.id_exame;

    getOpenFile(pdf_exame)
      .then(({ data }) => {
        const url = window.URL.createObjectURL(
          new Blob([data], { type: "application/pdf" })
        );

        const a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.target = "_blank";
        a.href = url;
        a.download = filename;
        a.click();
        document.body.removeChild(a);
      })
      .catch((error) => console.log(error));
  };

  const logo = process.env.PUBLIC_URL + "/logo.svg";

  return (
    <div className="container-exames">
      <div className="exames">
        <div className="exames-logo">
          <img src={logo} width={150} />
        </div>
        <div className="dados-paciente">
          <p className="dados-paciente-nome">
            <span>Nome:</span>
            {nome}
          </p>
          <p className="dados-paciente-cpf">
            <span>CPF:</span>
            {cpf}
          </p>
          <div className="dados-paciente-auth">
            <p>
              <span>CPF:</span>
              {cpf}
            </p>
            <p>
              <span>Data Nascto:</span>
              {dt_nascimento}
            </p>
            <p>
              <span>ID do Paciente:</span>
              {id_paciente}
            </p>
          </div>
        </div>
        <div className="resultados">
          <div className="list-header">
            <p>LISTAGEM DE EXAMES</p>
          </div>
          <div className="list-content">
            {resultados.map((item) => (
              <div key={item.pdf_exame} className="list-row">
                <p>
                  {moment(item.dt_exame).format("DD/MM/YYYY")} -{" "}
                  {item.procedimento}
                </p>
                <button onClick={() => downloadPdfExame(item)}>
                  <img
                    src={`${process.env.PUBLIC_URL}/download_pdf.png`}
                    alt="Download PDF"
                  />
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Exames;
